import React from "react";

function VenueListItem({
    venue,
    editVenue,
    handleAddEvent,
    actionLabel = "Hide",
    actionHandler,
    unpublishVenue,
    publishVenue,
}) {
    return (
        <React.Fragment key={venue._id}>
            <li className="py-2 border-b border-[#444]">
                <div className="flex flex-col lg:flex-row justify-between items-center mt-2 md:mt-0 bg-[#2a2a2a] p-2">
                    <div className="flex">
                        {!venue.published && (
                            <span className="px-2 py-0.5 text-xs bg-[#555] text-[#f0f0f0] rounded">
                                Unpublished
                            </span>
                        )}
                        {venue.cityNew?.name &&
                            <li className="pl-4 font-semibold">
                                {venue.cityNew?.name}{" | "}
                            </li>
                        }
                        <span className="text-white ml-1">{venue.name}</span>
                    </div>
                    <div className="flex gap-2">
                        <button
                            onClick={() => editVenue(venue)}
                            className="px-3 py-1 bg-[#4CAF50] hover:bg-[#45a049] text-white text-sm rounded-md transition-colors"
                        >
                            Edit
                        </button>
                        <button
                            onClick={() => handleAddEvent(venue)}
                            className="px-3 py-1 bg-[#d4a017] hover:bg-[#b38b00] text-white text-sm rounded-md transition-colors"
                        >
                            Add Event
                        </button>
                        <button
                            onClick={() => actionHandler(venue._id)}
                            className="px-3 py-1 bg-[#f44336] hover:bg-[#da190b] text-white text-sm rounded-md transition-colors"
                        >
                            {actionLabel}
                        </button>
                        {venue.published ? (
                            <button
                                onClick={() => unpublishVenue(venue._id)}
                                className="px-3 py-1 bg-blue-700 hover:bg-blue-800 text-white text-sm rounded-md transition-colors"
                            >
                                Unpublish
                            </button>
                        ) : (
                            <button
                                onClick={() => publishVenue(venue._id)}
                                className="px-3 py-1 mx-2 bg-blue-700 hover:bg-blue-800 text-white text-sm rounded-md transition-colors"
                            >
                                Publish
                            </button>
                        )}
                    </div>
                </div>
            </li>
        </React.Fragment>
    );
}

export default VenueListItem;